import { render, staticRenderFns } from "./pg_company_philosophy.vue?vue&type=template&id=ef3f6ccc"
import script from "./pg_company_philosophy.vue?vue&type=script&lang=js"
export * from "./pg_company_philosophy.vue?vue&type=script&lang=js"
import style0 from "./pg_company_philosophy.vue?vue&type=style&index=0&id=ef3f6ccc&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports